import type { SDKConfig } from "@frontend/roz-sdk-core";

import type { StandardShellProps } from "@/presets/StandardShell";

type ShellProps = Omit<StandardShellProps, "children">;

export interface LoaderConfig extends SDKConfig, ShellProps {
  shell?: string;
}

const SDK_CONFIG_KEYS = [
  "authProps",
  "theme",
  "analytics",
  "revive",
  "_usage",
  "debug",
] as const;

const SHELL_PROP_KEYS = [
  "searchEnabled",
  "cookieBannerEnabled",
  "maintenanceBannerEnabled",
  "gtmEnabled",
  "footerContainerId",
  "hideHeader",
  "hideFooter",
] as const;

export function splitLoaderConfig(config: LoaderConfig): {
  sdkConfig: SDKConfig;
  shellName?: string;
} {
  const sdkConfig: SDKConfig = {};
  for (const key of SDK_CONFIG_KEYS) {
    if (config[key] !== undefined) {
      // biome-ignore lint/suspicious/noExplicitAny: index over known key union
      (sdkConfig as any)[key] = config[key];
    }
  }
  if (sdkConfig._usage === undefined) {
    sdkConfig._usage = "external";
  }
  return { sdkConfig, shellName: config.shell };
}

export function shellPropsFromConfig(config: LoaderConfig): ShellProps {
  const props: ShellProps = {};
  for (const key of SHELL_PROP_KEYS) {
    if (config[key] !== undefined) {
      // biome-ignore lint/suspicious/noExplicitAny: index over known key union
      (props as any)[key] = config[key];
    }
  }
  return props;
}
